module.exports = __webpack_public_path__ + "images/spinner_9bb3909ff2608b56b243f55c15aa716d.gif";